import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import BottomNav from 'src/components/bottom-nav.component';

const ContactUSPage = () => {

  document.title = 'Messages | SNB';

  const navigate = useNavigate();

  return (
    <div className='home-wrapper app-wrapper agenda-page has-bottom-nav'>
      <div className='page-content'>
        <div className='agenda-topbar'>
          <ArrowBackIcon role='button' onClick={() => navigate('/home')} />
        </div>

        <h1 className='agenda-title'>Messages</h1>
        <p className='agenda-muted'>Your event support contact</p>

        <ul className='agenda-list'>
          <li>
            <PersonOutlineIcon className='agenda-list-icon' />
            <div>
              <div>Mr. Omar Ghurab</div>
              <div className='agenda-muted'>Event support</div>
            </div>
          </li>
          <li>
            <PhoneOutlinedIcon className='agenda-list-icon' />
            <a className='contact-link' href='tel:+966504108080'>+966 50 410 8080</a>
          </li>
          <li>
            <EmailOutlinedIcon className='agenda-list-icon' />
            <a className='contact-link' href='mailto:o.ghurab@alahli.com'>o.ghurab@alahli.com</a>
          </li>
        </ul>

        <a className='agenda-restaurant-link contact-whatsapp' href='https://wa.me/966504108080' target='_blank' rel='noopener noreferrer'>
          <WhatsAppIcon className='agenda-list-icon' />
          <span>
            WhatsApp Support
            <div className='agenda-muted'>Tap to chat</div>
          </span>
          <ChevronRightRoundedIcon />
        </a>
      </div>
      <BottomNav />
    </div>
  );
};

export default ContactUSPage;
